// Data attributes:
//   data-smd-parallax="subtle|slow|fast|subtle-reverse|slow-reverse"
//   data-smd-parallax-min-width="N"  — disable below N px
//   data-smd-parallax-max-down="N"   — clamp positive translateY to N
//   data-smd-parallax-max-up="N"     — clamp |negative translateY| to N

(function initParallax() {
  const SPEEDS = {
    subtle: -0.05,
    slow: -0.15,
    fast: -0.40,
    'subtle-reverse': 0.05,
    'slow-reverse': 0.15,
  };

  const ready = (cb) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cb, { once: true });
    } else {
      cb();
    }
  };

  ready(() => {
    const nodes = document.querySelectorAll('[data-smd-parallax]');
    if (!nodes.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;

    const containerFor = (el) => el.closest('.use-tailwind') || document.body;
    const containers = new Map();

    nodes.forEach((el) => {
      const speedKey = el.dataset.smdParallax;
      const speed = SPEEDS[speedKey];
      if (!Number.isFinite(speed)) return;

      const minWidthAttr = parseInt(el.dataset.smdParallaxMinWidth, 10);
      const minWidth = Number.isFinite(minWidthAttr) ? minWidthAttr : 0;

      const maxDownAttr = parseFloat(el.dataset.smdParallaxMaxDown);
      const maxDown = Number.isFinite(maxDownAttr) ? maxDownAttr : Infinity;
      const maxUpAttr = parseFloat(el.dataset.smdParallaxMaxUp);
      const maxUp = Number.isFinite(maxUpAttr) ? maxUpAttr : Infinity;

      const container = containerFor(el);
      if (!containers.has(container)) {
        containers.set(container, { elements: [], active: false });
      }
      containers.get(container).elements.push({ el, speed, minWidth, maxDown, maxUp });

      // Pre-set a 3d transform so the first paint doesn't jump on first scroll.
      el.style.willChange = 'transform';
      el.style.transform = 'translate3d(0, 0, 0)';
    });

    if (!containers.size) return;

    let pendingFrame = null;

    const update = () => {
      pendingFrame = null;
      const viewportH = window.innerHeight;

      containers.forEach((state, container) => {
        if (!state.active) return;

        const rect = container.getBoundingClientRect();
        const blockCentre = rect.top + rect.height / 2;
        const viewportCentre = viewportH / 2;
        const delta = blockCentre - viewportCentre;

        state.elements.forEach(({ el, speed, minWidth, maxDown, maxUp }) => {
          let translateY = window.innerWidth >= minWidth ? delta * speed : 0;
          if (translateY > maxDown) translateY = maxDown;
          if (translateY < -maxUp) translateY = -maxUp;
          el.style.transform = `translate3d(0, ${translateY.toFixed(2)}px, 0)`;
        });
      });
    };

    const scheduleUpdate = () => {
      if (pendingFrame != null) return;
      pendingFrame = requestAnimationFrame(update);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const state = containers.get(entry.target);
          if (!state) return;
          state.active = entry.isIntersecting;
          if (state.active) {
            scheduleUpdate();
          }
        });
      },
      { rootMargin: '100px' }
    );

    containers.forEach((_state, container) => observer.observe(container));

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);

    scheduleUpdate();
  });
})();
